import React, { useState } from "react";
import {
  iconArray,
  navActiveCss,
  navHoverCss,
  spIconArray,
  superAdminIconArray,
} from "../../constants/NavbarRoutesArray";
import Navbar from "../../Components/Navbar-Comps/Navbar";
import greenTick from "../../Assets/images/greenTick.svg";
import redCross from "../../Assets/images/redCross.svg";
import hut from "../../Assets/images/hut.svg";
import logo from "../../Assets/images/LOGO.svg";
import { FaAngleRight } from "react-icons/fa";
import { AiOutlineCheck } from "react-icons/ai";
import { PatientDetailsSection } from "../../Components/Order-Comps/PatientDetailsSection";
import UploadPhotoGraphsSection from "../../Components/Order-Comps/UploadPhotoGraphsSection";
import OrthodonticCaseDetailsSection from "../../Components/Order-Comps/OrthodonticCaseDetailsSection";
import OrthodonticOrderConfirmation from "../OrderConfirmation/OrthodonticOrderConfirmation";
import { useLocation } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { LoginButton } from "../Login/Login";
import { Tooltip } from "react-tooltip";
import { useEffect } from "react";
import { useGetOrderByIdMutation } from "../../services/orders";
import Notification from "../../Components/Notification/Notification";
import { useDispatch, useSelector } from "react-redux";
import { DisclaimerSection } from "../../Components/Order-Comps/DisclaimerSection";
import { orthodonticTermsAndConditions } from "../../constants/OrderFormsDisclaimers";
import { setOrthodonticOrderDetails } from "../../reducers/orderFormReducer";
import { orthodonticInitialOrderDetails } from "../../Utils/orderFormInitialDetails";

function OrthodonticOrderDetails({ userRole, userInfo }) {
  const location = useLocation();
  return (
    <div className="flex bg-black">
      <Navbar
        iconArray={
          userRole === "89uij7"
            ? superAdminIconArray
            : userRole === "676dza2"
            ? iconArray
            : spIconArray
        }
        navHoverCss={navHoverCss}
        navActiveCss={navActiveCss}
        middleSection={false}
        middleTabTitleArray={[""]}
        middleTabContentObject={{}}
        userRole={userRole}
        active="Orders"
      />
      <OrderDetailsTab
        serviceObjId={location.state.serviceObjId ? location.state.serviceObjId : ""}
        orderByIdData={location.state.orderByData}
        userInfo={userInfo}
        userRole={userRole}
      />
    </div>
  );
}

export default OrthodonticOrderDetails;

export const OrderDetailsTab = ({ userRole, userInfo, serviceObjId, orderByIdData }) => {
  const dispatch = useDispatch();
  const orderId = orderByIdData?._id;
  const [orderByData, setorderByData] = useState(orderByIdData);
  const { getAccessTokenSilently } = useAuth0();
  const [getOrderById] = useGetOrderByIdMutation();
  const personalDetails = useSelector((state) => state.personalDetails);

  const { user, isAuthenticated } = useAuth0();
  const [isDisclaimerAccepted, setIsDisclaimerAccepted] = useState(false);
  const [orderForService, setOrderForService] = useState({ serviceObjId: serviceObjId });

  const { orthodonticOrderDetails } = useSelector((state) => state.orderFormDetails);

  console.log("orthodonticOrderDetails", orthodonticOrderDetails);

  const tabNamesArray = ["Patient Details", "Case Details", "Upload Files", "Disclaimers"];
  const [activeTab, setActiveTab] = useState(tabNamesArray[0]);

  const isFieldRequired = (fieldName) => {
    const requiredFields = ["intraOralScans", "photographs"];

    return requiredFields.includes(fieldName);
  };

  useEffect(() => {
    dispatch(
      setOrthodonticOrderDetails({
        ...orthodonticOrderDetails,
        isPriority: orderByIdData?.isPriority,
        expectedDelivery: orderByIdData?.expectedDelivery,
        serviceObjId: serviceObjId,
      })
    );

    return () => dispatch(setOrthodonticOrderDetails(orthodonticInitialOrderDetails));
  }, []);

  const submitedPatientDetails = (data) => {
    dispatch(
      setOrthodonticOrderDetails({
        ...orthodonticOrderDetails,
        patientDetails: data,
      })
    );
  };

  const submitedCaseDetails = (data) => {
    dispatch(
      setOrthodonticOrderDetails({
        ...orthodonticOrderDetails,
        caseDetails: data,
      })
    );
  };

  const submitedUploadData = (data) => {
    dispatch(
      setOrthodonticOrderDetails({
        ...orthodonticOrderDetails,
        uploadFiles: data,
      })
    );
  };

  const submitDisclaimerData = (data) => {
    dispatch(
      setOrthodonticOrderDetails({
        ...orthodonticOrderDetails,
        disclaimers: data,
      })
    );
    setIsDisclaimerAccepted(true);
  };

  const outputObject = {
    "Patient Details": (
      <PatientDetailsSection
        orderObjId={orderByData?._id}
        orderByData={orderByData}
        serviceObjId={serviceObjId}
        setActiveTab={setActiveTab}
        orderPatientData={orthodonticOrderDetails?.patientDetails}
        submitOrderData={submitedPatientDetails}
      />
    ),
    "Case Details": (
      <OrthodonticCaseDetailsSection
        orderObjId={orderByData?._id}
        orderByData={orderByData}
        serviceObjId={serviceObjId}
        setActiveTab={setActiveTab}
        orderCaseData={orthodonticOrderDetails?.caseDetails}
        submitOrderData={submitedCaseDetails}
      />
    ),
    "Upload Files": (
      <UploadPhotoGraphsSection
        orderObjId={orderByData?._id}
        orderByData={orderByData}
        serviceObjId={serviceObjId}
        setActiveTab={setActiveTab}
        orderUploadData={orthodonticOrderDetails?.uploadFiles}
        submitOrderData={submitedUploadData}
        isFieldRequired={isFieldRequired}
      />
    ),
    Disclaimers: (
      <DisclaimerSection
        orderObjId={orderByData?._id}
        orderByData={orderByData}
        serviceObjId={serviceObjId}
        submitOrderData={submitDisclaimerData}
        setActiveTab={setActiveTab}
        tncList={orthodonticTermsAndConditions}
      />
    ),
  };

  const handleTabSuper = (tabName) => {
    setActiveTab(tabName);
  };

  // useEffect(() => {
  //   if (orderUpdated === true) {
  //     const getOrderData = async () => {
  //       const accessToken = await getAccessTokenSilently({
  //         authorizationParams: {
  //           audience: process.env.REACT_APP_AUDIENCE_URL, // Value in Identifier field for the API being called.
  //         },
  //       });
  //       const resp = await getOrderById({
  //         accessToken,
  //         orderId: orderId,
  //       });
  //       if (resp?.data) {
  //         setorderByData(resp.data.data[0]);
  //       }
  //     };
  //     getOrderData();
  //   }
  // }, [orderUpdated]);

  return (
    <>
      {isDisclaimerAccepted ? (
        <OrthodonticOrderConfirmation
          userInfo={userInfo}
          userRole={userRole}
          orderObjId={orderByData?._id}
          orderFor={orderForService}
          setActiveTab={setActiveTab}
          setIsDisclaimerAccepted={setIsDisclaimerAccepted}
        />
      ) : (
        <div className="MAIN-DASH bg-black md:p-4 px-4 pt-4 pb-20 w-full min-h-screen h-fit flex flex-col">
          <div className="NAVBAR flex justify-between items-center mb-4 ">
            <p className="text-[15px] text-[#999999] flex justify-between items-center">
              <img src={logo} className="mx-auto w-[50px] h-[40px] mr-4 block md:hidden" alt="" />
              <span>
                <img src={hut} alt="" />
              </span>
              <span className="ml-3">Dashboard</span>
            </p>
            <div className="flex gap-4 items-center">
              {isAuthenticated ? (
                <div className="text-[15px] justify-center items-center hidden md:flex text-white">
                  Hello, {personalDetails.data[0]?.firstName ?? user.name}
                </div>
              ) : (
                <LoginButton />
              )}
              {userRole !== "89uij7" ? (
                userInfo?.length > 0 ? (
                  <button className="relative px-4 py-2 flex items-center rounded-xl bg-secondary font-medium text-[15px] text-white">
                    {userInfo[0]?.active === 1 ? (
                      <>
                        {userInfo[0]?.crowdHireId}
                        <img className="relative top-[4px] right-0" src={greenTick} alt="" />
                      </>
                    ) : (
                      <div
                        className="flex"
                        data-tooltip-id="status"
                        data-tooltip-content={
                          "Your registration is under review and you will be notified once admin approves your registration."
                        }
                      >
                        <span className="text-orange-600">{userInfo[0]?.crowdHireId}</span>
                        <img
                          className="relative top-[0px] ml-2 right-0 h-5 w-5"
                          src={redCross}
                          alt=""
                        />
                        <Tooltip id="status" place="bottom" />
                      </div>
                    )}
                  </button>
                ) : (
                  <button className="relative px-4 py-2 flex items-center rounded-xl bg-secondary font-medium text-[15px] text-white">
                    Account Not Active
                    <img className="relative top-[0px] right-0 h-5 w-5" src={redCross} alt="" />
                  </button>
                )
              ) : (
                <></>
              )}

              <Notification />
            </div>
          </div>
          <p className="font-medium text-[34px] text-white">Orthodontic Service</p>
          <div className="ORDER-DETAIL-COMPONENT flex-1 flex flex-col h-full rounded-xl">
            <div className="bg-backgroundV2 flex flex-row flex-wrap items-center gap-4 md:justify-around justify-between md:px-0 px-4 py-4 mb-4">
              <div className="flex items-center gap-4">
                <div className="bg-[#8ED259] h-8 w-8 rounded-full text-white font-medium flex items-center justify-center">
                  <AiOutlineCheck className=" " />
                </div>
                <p className="font-semibold text-white md:block hidden ">Service Details</p>
              </div>
              <div className="md:w-[200px] h-[20px] ">
                <FaAngleRight className="mx-auto text-[#8ED259] text-xl md:rotate-0 " />
              </div>
              <div className="flex items-center gap-4">
                <div className="bg-orange-500 h-8 w-8 rounded-full border text-white font-medium flex items-center justify-center">
                  2
                </div>
                <p className="text-white font-semibold md:block hidden ">Order Details</p>
              </div>
              <div className="md:w-[200px] h-[20px] md:rotate-0 ">
                <FaAngleRight className="mx-auto text-white " />
              </div>
              <div className="flex items-center gap-4">
                <div className="bg-white h-8 w-8 rounded-full border text-[#999] font-medium flex items-center justify-center">
                  3
                </div>
                <p className="text-white md:block hidden ">Confirmation</p>
              </div>
            </div>
            <div className="TAB-SECTION flex-1 flex md:flex-row flex-col p-4 h-full bg-secondary">
              <ul className="NAV md:pr-8 flex flex-col items-start md:gap-4 gap-0 text-[16px] leading-4 font-medium md:border-r border-b border-[#222026] border-opacity-10">
                {tabNamesArray.map((title, i) => {
                  return (
                    <li
                      key={i}
                      className="relative w-full"
                      //onClick={() => handleTabSuper(title)}
                    >
                      <div
                        className={
                          activeTab === title
                            ? "text-white bg-primary w-full p-4 rounded-lg"
                            : "hover:text-white hover:bg-primary cursor-pointer text-white font-normal w-full p-4 rounded-lg"
                        }
                      >
                        {title}
                      </div>
                    </li>
                  );
                })}
              </ul>

              <div className="outlet flex flex-col flex-1 overflow-visible w-full md:py-4 md:pl-8  md:pr-4 p-2 ">
                {Object.keys(outputObject).map((key) => {
                  if (tabNamesArray.includes(key)) {
                    return <>{activeTab === key ? <>{outputObject[key]}</> : null}</>;
                  }
                  return null;
                })}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
